import React from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

interface Props {
  style?: StyleProp<ViewStyle>;
  children?: React.ReactNode;
  overlay?: React.ReactNode;
  fill?: boolean;
  disabled?: boolean;
  onPress?(node: React.Component): void;
}

export function MBTouchableOverlay({ style, overlay, children, fill, disabled, onPress }: Props) {
  const ref = React.useRef<TouchableOpacity>(null);
  const [pressed, setPressed] = React.useState(false);
  const press = React.useCallback(() => {
    if (onPress && ref.current) {
      onPress(ref.current);
    }
  }, [onPress]);
  const pressIn = React.useCallback(() => setPressed(true), [setPressed]);
  const pressOut = React.useCallback(() => setPressed(false), [setPressed]);

  return (
    <TouchableOpacity
      ref={ref}
      style={[style, fill ? { flex: 1 } : null]}
      disabled={disabled}
      activeOpacity={1}
      onPress={!!onPress ? press : undefined}
      onPressIn={!!onPress ? pressIn : undefined}
      onPressOut={!!onPress ? pressOut : undefined}
    >
      {children}
      {pressed && overlay}
    </TouchableOpacity>
  );
}
